import Image from 'next/image';
import styled from 'styled-components';
import {
  color,
  fontFamily,
  fontSize,
  fontWeight,
  spacing
} from '../../../theme';

export const StyledWhenHighlightsItem = styled.div`
  display: flex;
  align-items: center;
  //margin-bottom: ${spacing('xl3')};
`;

export const StyledWhenHighlightsItemIcon = styled(Image)`
  display: block;
  width: ${spacing('xl4')};
`;

export const StyledWhenHighlightsItemContent = styled.div`
  flex-grow: 1;
  margin-left: ${spacing('md')};
`;

export const StyledWhenHighlightsItemTitle = styled.h3`
  color: ${color('text_subtle')};
  font-weight: ${fontWeight('black')};
  text-transform: uppercase;
  font-size: ${fontSize('md')};
  line-height: 1.25;
  margin-top: 0;
  margin-bottom: ${spacing('xs')};
`;

export const StyledWhenHighlightsItemValue = styled.span`
  display: block;
  font-family: ${fontFamily('display')};
  font-weight: ${fontWeight('light')};
  font-size: ${fontSize('xl4')};
  line-height: 1;
  text-transform: uppercase;
`;

export const StyledWhenHighlightsItemExtra = styled.span`
  display: block;
  font-family: ${fontFamily('display')};
  font-weight: ${fontWeight('light')};
  font-size: ${fontSize('xl2')};
  line-height: 1;
  text-transform: uppercase;
  margin-top: ${spacing('xs')};
`;
